<div class="mainContent">
    <div class="viewer-area">
        <div class="viewer-wrapper">
            <div class="thumbnail-panel">
                <div class="thumb-wrapper" *ngFor="let page of scannedPages; let i = index"
                    (dragover)="onDragOver($event)" (drop)="onDrop($event, i)">
                    <div class="thumb" [class.active]="i === selectedPageIndex" draggable="true"
                        (dragstart)="onDragStart($event, i)" (dragend)="onDragEnd()" (click)="selectPage(i)">
                        <img [src]="page.dataUrl" draggable="false" />
                        <div class="delete-icon" (click)="deletePage(i, $event)">
                            <img src="../../../assets/Images/document-preview/trash.svg" alt="delete">
                        </div>
                        <div class="page-badge">{{ i + 1 }}</div>
                    </div>
                </div>
            </div>
            <div class="viewer-divider"></div>
            <div class="preview-panel">
                <div class="preview-content" #previewPanel (scroll)="onPreviewScroll($event)">
                    <div *ngFor="let page of scannedPages; let i = index" [id]="'page-' + i"
                        class="preview-page-wrapper">
                        <img [src]="page.dataUrl" class="preview-image" />
                        <div class="page-number">Page {{ i + 1 }}</div>
                    </div>
                </div>
                <div *ngIf="isLoading" class="loader-overlay">
                    <div class="loader"></div>
                </div>
            </div>
        </div>
    </div>
    <div class="scan-info">
        <div>
            <div class="modal-body">
                <ul class="list-group">
                    <li class="list-group-item">
                        <div class="documentType__dropdown">
                            <div class="documentType__dropdownLabel">Device</div>
                            <select class="docType__dropdownOptions" [(ngModel)]="selectedScannerId">
                                <option value="">Choose...</option>
                                <option *ngFor="let scanner of scannerList" [value]="scanner.id">
                                    {{ scanner.name }}
                                </option>
                            </select>
                        </div>
                    </li>
                    <li class="list-group-item">
                        <div class="input-group-prepend" style="display: flex;">
                            <label class="input-group-text" style="width: 49%; margin-right: 2%;">
                                <input type="checkbox" class="checkbox-btn" [(ngModel)]="scanOptions.IfFeederEnabled">
                                &nbsp;&nbsp;AutoFeeder
                            </label>
                            <label class="input-group-text" style="width: 49%;">
                                <input type="checkbox" class="checkbox-btn" [(ngModel)]="scanOptions.duplex">
                                &nbsp;&nbsp;Duplex
                            </label>
                        </div>
                    </li>
                    <li class="list-group-item">
                        <div class="input-group-prepend" style="display: flex;">
                            <label class="input-group-text" style="width: 32%; margin-right: 2%;">
                                <input type="radio" class="checkbox-btn" [(ngModel)]="scanOptions.colorMode" value="BlackAndWhite">
                                &nbsp;&nbsp;B&amp;W
                            </label>
                            <label class="input-group-text" style="width: 32%; margin-right: 2%;">
                                <input type="radio" class="checkbox-btn" [(ngModel)]="scanOptions.colorMode" value="Grayscale">
                                &nbsp;&nbsp;Gray
                            </label>
                            <label class="input-group-text" style="width: 32%;">
                                <input type="radio" class="checkbox-btn" [(ngModel)]="scanOptions.colorMode" value="Color">
                                &nbsp;&nbsp;Color
                            </label>
                        </div>
                    </li>
                    <li class="list-group-item">
                        <div class="documentType__dropdown">
                            <div class="documentType__dropdownLabel">Resolution</div>
                            <select class="docType__dropdownOptions" [(ngModel)]="scanOptions.Resolution">
                                <option selected>Choose...</option>
                                <option value="100">100</option>
                                <option value="150">150</option>
                                <option value="200">200</option>
                                <option value="300">300</option>
                            </select>
                        </div>
                    </li>
                </ul>
                <div class="modal-footer">
                    <app-common-button buttonClass="smallFilledButton" [buttonLabel]="'Scan'" [typeBtn]="true"
                     [disabled]="isLoading"  (click)="scanDocument()">
                    </app-common-button>
                    <app-common-button [buttonLabel]="'Upload'" [typeBtn]="true" buttonClass="ssoButton"
                        (click)="uploadToPdf()" *ngIf="scannedPages.length > 0">
                    </app-common-button>
                    <app-common-button [buttonLabel]="'Save as PDF'" [typeBtn]="true" buttonClass="ssoButton"
                        (click)="saveAsPdf()" *ngIf="scannedPages.length > 0">
                    </app-common-button>
                </div>
                <div class="text-center" *ngIf="errorMessage">
                    <small class="text-danger">{{ errorMessage }}</small>
                </div>
            </div>
        </div>
    </div>
</div>
<hr>
<div *ngIf="isSuccessToster">
    <app-toast [title]="message" (closeToaster)="closeToster($event)"></app-toast>
</div>